import { render } from "./ButtonProperty1PrimaryHoverFalse.vue?vue&type=template&id=22d31839&scoped=true"
import script from "./ButtonProperty1PrimaryHoverFalse.vue?vue&type=script&lang=js"
export * from "./ButtonProperty1PrimaryHoverFalse.vue?vue&type=script&lang=js"

import "./ButtonProperty1PrimaryHoverFalse.vue?vue&type=style&index=0&id=22d31839&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d31839"]])

export default __exports__